module.exports = __webpack_public_path__ + "static/media/sf_2300_gray.36a78a8c7e0ad2691c5ded083b0dcce9.png";